var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormPanel',{attrs:{"headline":"Create Registration Category","errors":_vm.errors},on:{"submit":_vm.submit}})
}
var staticRenderFns = []

export { render, staticRenderFns }